/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
'use strict';
module.exports = [
  '$filter',
  'translateFilter',
  'zonedDateTimeToDateFilter',
  'clazzNodeFilter',
  'datex2EnumsTranscodeFilter',
  'validityPeriodsToStringFilter',
  'sourceTranscodeFilter',
  function (
    $filter,
    translateFilter,
    zonedDateTimeToDateFilter,
    clazzNodeFilter,
    datex2EnumsTranscodeFilter,
    validityPeriodsToStringFilter,
    sourceTranscodeFilter
  ) {
    var situationRecord = {};
    var ret = undefined;
    var situationRecordTypes = {
      situationRecordFilter:
        'com.dromedian.jdro.datex2.domain.SituationRecordFilterEntity',
      situationRecord: 'com.dromedian.jdro.datex2.domain.SituationRecordEntity',
      //classi astratte
      operatorAction: 'com.dromedian.jdro.datex2.domain.OperatorActionEntity',
      roadworks: 'com.dromedian.jdro.datex2.domain.RoadworksEntity',
      nonRoadEventInformation:
        'com.dromedian.jdro.datex2.domain.NonRoadEventInformationEntity',
      trafficElement: 'com.dromedian.jdro.datex2.domain.TrafficElementEntity',
      obstruction: 'com.dromedian.jdro.datex2.domain.ObstructionEntity',
      equipmentOrSystemFault:
        'com.dromedian.jdro.datex2.domain.EquipmentOrSystemFaultEntity',
      abnormalTraffic: 'com.dromedian.jdro.datex2.domain.AbnormalTrafficEntity',
      generalObstruction:
        'com.dromedian.jdro.datex2.domain.GeneralObstructionEntity',
      //classi concrete
      environmentalObstruction:
        'com.dromedian.jdro.datex2.domain.EnvironmentalObstructionEntity',
      infrastructureDamageObstruction:
        'com.dromedian.jdro.datex2.domain.InfrastructureDamageObstructionEntity',
      animalPresenceObstruction:
        'com.dromedian.jdro.datex2.domain.AnimalPresenceObstructionEntity',
      vehicleObstruction:
        'com.dromedian.jdro.datex2.domain.VehicleObstructionEntity',
      accident: 'com.dromedian.jdro.datex2.domain.AccidentEntity',
      authorityOperation:
        'com.dromedian.jdro.datex2.domain.AuthorityOperationEntity',
      disturbanceActivity:
        'com.dromedian.jdro.datex2.domain.DisturbanceActivityEntity',
      nonWeatherRelatedRoadConditions:
        'com.dromedian.jdro.datex2.domain.NonWeatherRelatedRoadConditionsEntity',
      weatherRelatedRoadConditions:
        'com.dromedian.jdro.datex2.domain.WeatherRelatedRoadConditionsEntity',
      poorEnvironmentConditions:
        'com.dromedian.jdro.datex2.domain.PoorEnvironmentConditionsEntity',
      constructionWorks:
        'com.dromedian.jdro.datex2.domain.ConstructionWorksEntity',
      maintenanceWorks:
        'com.dromedian.jdro.datex2.domain.MaintenanceWorksEntity',
      signSetting: 'com.dromedian.jdro.datex2.domain.SignSettingEntity',
      generalNetworkManagement:
        'com.dromedian.jdro.datex2.domain.GeneralNetworkManagementEntity',
      networkManagement:
        'com.dromedian.jdro.datex2.domain.NetworkManagementEntity',
      speedManagement: 'com.dromedian.jdro.datex2.domain.SpeedManagementEntity',
      winterDrivingManagement:
        'com.dromedian.jdro.datex2.domain.WinterDrivingManagementEntity',
      generalInstructionOrMessageToRoadUsers:
        'com.dromedian.jdro.datex2.domain.GeneralInstructionOrMessageToRoadUsersEntity',
      roadOrCarriagewayOrLaneManagement:
        'com.dromedian.jdro.datex2.domain.RoadOrCarriagewayOrLaneManagementEntity',
      roadsideServiceDisruption:
        'com.dromedian.jdro.datex2.domain.RoadsideServiceDisruptionEntity',
      roadOperatorServiceDisruption:
        'com.dromedian.jdro.datex2.domain.RoadOperatorServiceDisruptionEntity',
    };

    situationRecord.getSituationRecordTypes = function () {
      return situationRecordTypes;
    };

    situationRecord.reset = function () {
      ret = undefined;
      return ret;
    };
    situationRecord.init = function (srType) {
      if (!ret) initSituationRecord();
      switch (srType) {
        //classi astratte
        case situationRecordTypes.operatorAction:
          initOperatorAction();
          break;
        case situationRecordTypes.roadworks:
          initRoadworks();
          break;
        case situationRecordTypes.nonRoadEventInformation:
          initNonRoadEventInformation();
          break;
        case situationRecordTypes.trafficElement:
          initTrafficElement();
          break;
        case situationRecordTypes.obstruction:
          initObstruction();
          break;
        //classi concrete
        case situationRecordTypes.equipmentOrSystemFault:
          initEquipmentOrSystemFault(srType);
          break;
        case situationRecordTypes.abnormalTraffic:
          initAbnormalTraffic(srType);
          break;
        case situationRecordTypes.generalObstruction:
          initGeneralObstruction(srType);
          break;
        case situationRecordTypes.environmentalObstruction:
          initEnvironmentalObstruction(srType);
          break;
        case situationRecordTypes.infrastructureDamageObstruction:
          initInfrastructureDamageObstruction(srType);
          break;
        case situationRecordTypes.animalPresenceObstruction:
          initAnimalPresenceObstruction(srType);
          break;
        case situationRecordTypes.vehicleObstruction:
          initVehicleObstruction(srType);
          break;
        case situationRecordTypes.accident:
          initAccidentEntity(srType);
          break;
        case situationRecordTypes.authorityOperation:
          initAuthorityOperation(srType);
          break;
        case situationRecordTypes.disturbanceActivity:
          initDisturbanceActivity(srType);
          break;
        case situationRecordTypes.nonWeatherRelatedRoadConditions:
          initNonWeatherRelatedRoadConditions(srType);
          break;
        case situationRecordTypes.weatherRelatedRoadConditions:
          initWeatherRelatedRoadConditions(srType);
          break;
        case situationRecordTypes.poorEnvironmentConditions:
          initPoorEnvironmentConditions(srType);
          break;
        case situationRecordTypes.constructionWorks:
          initConstructionWorks(srType);
          break;
        case situationRecordTypes.maintenanceWorks:
          initMaintenanceWorks(srType);
          break;
        case situationRecordTypes.signSetting:
          initSignSetting(srType);
          break;
        case situationRecordTypes.generalNetworkManagement:
          initGeneralNetworkManagement(srType);
          break;
        case situationRecordTypes.networkManagement:
          initNetworkManagement(srType);
          break;
        case situationRecordTypes.speedManagement:
          initSpeedManagement(srType);
          break;
        case situationRecordTypes.winterDrivingManagement:
          initWinterDrivingManagement(srType);
          break;
        case situationRecordTypes.generalInstructionOrMessageToRoadUsers:
          initGeneralInstructionOrMessageToRoadUsers(srType);
          break;
        case situationRecordTypes.roadOrCarriagewayOrLaneManagement:
          initRoadOrCarriagewayOrLaneManagement(srType);
          break;
        case situationRecordTypes.roadsideServiceDisruption:
          initRoadsideServiceDisruption(srType);
          break;
        case situationRecordTypes.roadOperatorServiceDisruption:
          initRoadOperatorServiceDisruption(srType);
          break;
        default:
      }
      return ret;
    };

    function initSituationRecord() {
      ret = {
        //campi classe abstract SituationRecordEntity
        id: 0,
        severity: 'NONE',
        version: undefined,
        capacityRemainig: 0,
        numberOfLanesRestricted: 0,
        numberOfOperationalLanes: 0,
        originalNumberOfLanes: 0,
        residualRoadWidth: 0,
        validityStatus: 'DEFINED_BY_VALIDITY_TIME_SPEC',
        probabilityOfOccurrence: 'CERTAIN',
        confidentiality: 'NO_RESTRICTION',
        clazz: undefined,
        validityPeriods: [],
        cause: undefined,
        source: undefined,
        comments: [
          { locale: 'IT', comment: '' }, //DESCRIZIONE IT
          { locale: 'IT', comment: '' }, //TITOLO IT
        ],

        location: undefined, //NB: UN PUNTO DEVE AVERE STRUTTURA [lon, lat]!!!!!!!!!!!
        //                //POINT: LO INSERISCO COME MULTIPOINT
        //                location: {
        //                    type: "MULTIPOINT",
        //                    coordinates: [[12.496355, 41.902735]]
        //                }
        //            location: {
        //                type: "MULTIPOINT",
        //                coordinates: [[12.4963655, 41.9027835], [12.4815742, 41.9264955], [12.433509, 41.9490335]]
        //            }

        //                location: {
        //                    type: "LINESTRING",
        //                    coordinates: [[12.49635, 41.90785], [12.48153, 41.926493], [12.4358, 41.949038]]
        //                }

        //TODO: CAMPI SITUATION RECORD protected protected OpenLrLocationEntity openLrLocation
        attachments: [],
      };
      return ret;
    }
    function initOperatorAction() {
      ret.actionOrigin = undefined;
      ret.operatorActionStatus = undefined;
      return ret;
    }
    function initRoadworks() {
      ret.mobilityType = undefined;
      ret.maintenanceVehicleActions = [];
      return ret;
    }
    function initNonRoadEventInformation() {
      return ret;
    }
    function initTrafficElement() {
      return ret;
    }
    function initObstruction() {
      return ret;
    }
    function initEquipmentOrSystemFault(srType) {
      ret.equipmentOrSystemFaultType = undefined;
      ret.faultyEquipmentOrSystemType = undefined;
      ret.clazz = srType;
      return ret;
    }
    function initAbnormalTraffic(srType) {
      ret.abnormalTrafficType = undefined;
      ret.queueLength = 0;
      ret.trafficFlowCharacteristics = undefined;
      ret.trafficTrendType = undefined;
      ret.clazz = srType;
      return ret;
    }
    function initGeneralObstruction(srType) {
      ret.obstructionType = [];
      ret.clazz = srType;
      return ret;
    }
    function initEnvironmentalObstruction(srType) {
      ret.environmentalObstructionType = undefined;
      ret.clazz = srType;
      return ret;
    }
    function initInfrastructureDamageObstruction(srType) {
      ret.infrastructureDamageType = undefined;
      ret.clazz = srType;
      return ret;
    }
    function initAnimalPresenceObstruction(srType) {
      ret.alive = false;
      ret.animalPresenceType = 'ANIMALS_ON_THE_ROAD';
      ret.clazz = srType;
      return ret;
    }
    function initVehicleObstruction(srType) {
      ret.vehicleObstructionType = undefined;
      ret.clazz = srType;
      return ret;
    }
    function initAccidentEntity(srType) {
      ret.accidentType = ['ACCIDENT'];
      ret.vehicleInvolved = [];
      ret.groupOfVehiclesInvolved = []; //TODO: DA GESTIRE
      ret.clazz = srType;
      return ret;
    }
    function initAuthorityOperation(srType) {
      ret.authorityOperationType = undefined;
      ret.clazz = srType;
      return ret;
    }
    function initDisturbanceActivity(srType) {
      ret.disturbanceActivityType = undefined;
      ret.clazz = srType;
      return ret;
    }
    function initNonWeatherRelatedRoadConditions(srType) {
      ret.nonWeatherRelatedRoadConditionType = [
        'ROAD_SURFACE_IN_POOR_CONDITION',
      ];
      ret.clazz = srType;
      return ret;
    }
    function initWeatherRelatedRoadConditions(srType) {
      ret.weatherRelatedRoadConditionType = [];
      ret.clazz = srType;
      return ret;
    }
    function initPoorEnvironmentConditions(srType) {
      ret.poorEnvironmentType = [];
      ret.clazz = srType;
      return ret;
    }
    function initConstructionWorks(srType) {
      ret.constructionWorkType = undefined;
      ret.clazz = srType;
      return ret;
    }
    function initMaintenanceWorks(srType) {
      ret.roadMaintenanceType = [];
      ret.clazz = srType;
      return ret;
    }
    function initSignSetting(srType) {
      ret.vmsSetting = null;
      ret.clazz = srType;
      return ret;
    }
    function initGeneralNetworkManagement(srType) {
      ret.generalNetworkManagementType = undefined;
      ret.clazz = srType;
      return ret;
    }
    function initNetworkManagement(srType) {
      ret.complianceOption = undefined;
      ret.automaticallyInitiated = false;
      ret.forVehiclesWithCharacteristicsOf = undefined; //TODO: forVehiclesWithCharacteristicsOf DA GESTIRE
      return ret;
    }
    function initSpeedManagement(srType) {
      ret.speedManagementType = undefined;
      ret.temporarySpeedLimit = 0;
      ret.clazz = srType;
      return ret;
    }
    function initWinterDrivingManagement(srType) {
      ret.winterEquipmentManagementType = undefined;
      ret.clazz = srType;
      return ret;
    }
    function initGeneralInstructionOrMessageToRoadUsers(srType) {
      ret.generalInstructionToRoadUsersType = undefined;
      ret.clazz = srType;
      return ret;
    }
    function initRoadOrCarriagewayOrLaneManagement(srType) {
      ret.roadOrCarriagewayOrLaneManagementType = undefined;
      ret.clazz = srType;
      return ret;
    }
    function initRoadsideServiceDisruption(srType) {
      ret.roadsideServiceDisruptionType = [];
      ret.clazz = srType;
      return ret;
    }
    function initRoadOperatorServiceDisruption(srType) {
      ret.roadOperatorServiceDisruptionType = [];
      ret.clazz = srType;
      return ret;
    }
    situationRecord.getCSVHeader = function () {
      var csvHeader = [
        //campi classe SituationRecordEntity
        translateFilter('AstralSituationRecord.id'),
        //, translateFilter('AstralSituationRecord.creationDate')
        translateFilter('AstralSituationRecord.createdUpdateDate'),
        translateFilter('AstralSituationRecord.createdUpdateBy'),
        translateFilter('AstralSituationRecord.publicSiteEvidence'),
        translateFilter('AstralSituationRecord.type'),
        translateFilter('AstralSituationRecord.source'),
        translateFilter('AstralSituationRecord.title'),
        translateFilter('AstralSituationRecord.description'),
        translateFilter('AstralSituationRecord.cause'),
        translateFilter('AstralSituationRecord.severity'),
        translateFilter('AstralSituationRecord.numberOfLanesRestricted'),
        translateFilter('AstralSituationRecord.numberOfOperationalLanes'),
        translateFilter('AstralSituationRecord.originalNumberOfLanes'),
        translateFilter('AstralSituationRecord.residualRoadWidth'),
        translateFilter('AstralSituationRecord.capacityRemainig'),
        //CAMPO NASCOSTO SULLE INTERFACCE translateFilter('AstralSituationRecord.validityStatus')
        translateFilter('AstralSituationRecord.validityPeriods'),
        translateFilter('AstralSituationRecord.probabilityOfOccurrence'),
        translateFilter('AstralSituationRecord.confidentiality'),
        //, translateFilter('AstralSituationRecord.location')
        //campi classe OperatorActionEntity
        translateFilter('AstralSituationRecord.actionOrigin'),
        translateFilter('AstralSituationRecord.operatorActionStatus'),
        //campi RoadworksEntity
        translateFilter('AstralSituationRecord.mobilityType'),
        translateFilter('AstralSituationRecord.maintenanceVehicleActions'),
        //CAMPO NASCOSTO SULLE INTERFACCE translateFilter('AstralSituationRecord.maintenanceVehicleActions')
        //campi EquipmentOrSystemFaultEntity
        translateFilter('AstralSituationRecord.equipmentOrSystemFaultType'),
        translateFilter('AstralSituationRecord.faultyEquipmentOrSystemType'),
        //campi AbnormalTrafficEntity
        translateFilter('AstralSituationRecord.abnormalTrafficType'),
        translateFilter('AstralSituationRecord.queueLength'),
        translateFilter('AstralSituationRecord.trafficFlowCharacteristics'),
        translateFilter('AstralSituationRecord.trafficTrendType'),
        //campi GeneralObstructionEntity
        translateFilter('AstralSituationRecord.obstructionType'),
        //campi EnvironmentalObstructionEntity
        translateFilter('AstralSituationRecord.environmentalObstructionType'),
        //campi InfrastructureDamageObstructionEntity
        translateFilter('AstralSituationRecord.infrastructureDamageType'),
        //campi AnimalPresenceObstructionEntity
        translateFilter('AstralSituationRecord.animalAlive'),
        //CAMPO NASCOSTO SULLE INTERFACCE translateFilter('AstralSituationRecord.animalPresenceType')
        //campi VehicleObstructionEntity
        translateFilter('AstralSituationRecord.vehicleObstructionType'),
        //campi AccidentEntityEntity
        //CAMPO NASCOSTO SULLE INTERFACCE , translateFilter('AstralSituationRecord.accidentType')
        //CAMPO NASCOSTO SULLE INTERFACCE translateFilter('AstralSituationRecord.vehicleInvolved')
        //CAMPO NASCOSTO SULLE INTERFACCE translateFilter('AstralSituationRecord.groupOfVehiclesInvolved')
        //campi AuthorityOperationEntity
        translateFilter('AstralSituationRecord.authorityOperationType'),
        //campi DisturbanceActivityEntity
        translateFilter('AstralSituationRecord.disturbanceActivityType'),
        //campi NonWeatherRelatedRoadConditionsEntity
        //CAMPO NASCOSTO SULLE INTERFACCE , translateFilter('AstralSituationRecord.nonWeatherRelatedRoadConditionType')
        //campi WeatherRelatedRoadConditionsEntity
        translateFilter(
          'AstralSituationRecord.weatherRelatedRoadConditionType'
        ),
        //campi PoorEnvironmentConditionsEntity
        translateFilter('AstralSituationRecord.poorEnvironmentType'),
        //campi ConstructionWorksEntity
        translateFilter('AstralSituationRecord.constructionWorkType'),
        //campi MaintenanceWorksEntity
        translateFilter('AstralSituationRecord.roadMaintenanceType'),
        //campi SignSettingEntity
        //CAMPO NASCOSTO SULLE INTERFACCE translateFilter('AstralSituationRecord.vmsSetting')
        //campi GeneralNetworkManagementEntity
        translateFilter('AstralSituationRecord.generalNetworkManagementType'),
        //campi NetworkManagementEntity
        translateFilter('AstralSituationRecord.complianceOption'),
        translateFilter('AstralSituationRecord.automaticallyInitiated'),
        //TODO: DA GESTIRE: forVehiclesWithCharacteristicsOf
        //campi SpeedManagementEntity
        translateFilter('AstralSituationRecord.speedManagementType'),
        translateFilter('AstralSituationRecord.temporarySpeedLimit'),
        //campi WinterDrivingManagementEntity
        translateFilter('AstralSituationRecord.winterEquipmentManagementType'),
        //campi GeneralInstructionOrMessageToRoadUsersEntity
        translateFilter(
          'AstralSituationRecord.generalInstructionToRoadUsersType'
        ),
        //campi RoadOrCarriagewayOrLaneManagementEntity
        translateFilter(
          'AstralSituationRecord.roadOrCarriagewayOrLaneManagementType'
        ),
        //campi RoadsideServiceDisruptionEntity
        translateFilter('AstralSituationRecord.roadsideServiceDisruptionType'),
        //campi RoadOperatorServiceDisruptionEntity
        translateFilter(
          'AstralSituationRecord.roadOperatorServiceDisruptionType'
        ),
      ];
      return csvHeader;
    };

    situationRecord.getCSVData = function (
      situationRecordList,
      situationRecordTypesTree,
      situationRecordSources,
      datex2Enums
    ) {
      var csvData = [];

      if (situationRecordList) {
        angular.forEach(situationRecordList, function (obj) {
          if (obj) {
            var row = {
              id: obj.id !== undefined && obj.id !== null ? obj.id : '',
              //createdDate: (obj.createdDate !== undefined && obj.createdDate !== null) ? $filter('date')(zonedDateTimeToDateFilter(obj.createdDate), "dd/MM/yyyy hh:mm") : "",
              createdUpdateDate:
                obj.updatedDate !== undefined && obj.updatedDate !== null
                  ? $filter('date')(
                      zonedDateTimeToDateFilter(obj.updatedDate),
                      'dd/MM/yyyy hh:mm'
                    )
                  : $filter('date')(
                      zonedDateTimeToDateFilter(obj.createdDate),
                      'dd/MM/yyyy hh:mm'
                    ),
              createdUpdateBy:
                obj.updatedBy !== undefined && obj.updatedBy !== null
                  ? obj.updatedBy
                  : obj.createdBy,
              publicSiteEvidence:
                obj.publicSiteEvidence !== undefined &&
                obj.publicSiteEvidence !== null
                  ? obj.publicSiteEvidence
                  : '',
              type:
                obj.clazz !== undefined && obj.clazz !== null
                  ? clazzNodeFilter(obj.clazz, situationRecordTypesTree)
                      .description
                  : '',
              source:
                obj.source !== undefined && obj.source !== null
                  ? sourceTranscodeFilter(obj.source, situationRecordSources)
                  : '',
              title:
                obj.comments[1].comment !== undefined &&
                obj.comments[1].comment !== null
                  ? obj.comments[1].comment
                  : '',
              description:
                obj.comments[0].comment !== undefined &&
                obj.comments[0].comment !== null
                  ? obj.comments[0].comment
                  : '',
              cause:
                obj.cause !== undefined && obj.cause !== null ? obj.cause : '',
              severity:
                obj.severity !== undefined && obj.severity !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.severity,
                      datex2Enums.severity
                    )
                  : '',
              numberOfLanesRestricted:
                obj.numberOfLanesRestricted !== undefined &&
                obj.numberOfLanesRestricted !== null
                  ? obj.numberOfLanesRestricted
                  : '',
              numberOfOperationalLanes:
                obj.numberOfOperationalLanes !== undefined &&
                obj.numberOfOperationalLanes !== null
                  ? obj.numberOfOperationalLanes
                  : '',
              originalNumberOfLanes:
                obj.originalNumberOfLanes !== undefined &&
                obj.originalNumberOfLanes !== null
                  ? obj.originalNumberOfLanes
                  : '',
              residualRoadWidth:
                obj.residualRoadWidth !== undefined &&
                obj.residualRoadWidth !== null
                  ? obj.residualRoadWidth
                  : '',
              capacityRemainig:
                obj.capacityRemainig !== undefined &&
                obj.capacityRemainig !== null
                  ? obj.capacityRemainig
                  : '',
              validityPeriods: validityPeriodsToStringFilter(
                obj.validityPeriods
              ),
              probabilityOfOccurrence:
                obj.probabilityOfOccurrence !== undefined &&
                obj.probabilityOfOccurrence !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.probabilityOfOccurrence,
                      datex2Enums.probabilityOfOccurrence
                    )
                  : '',
              confidentiality:
                obj.confidentiality !== undefined &&
                obj.confidentiality !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.confidentiality,
                      datex2Enums.confidentiality
                    )
                  : '',
              actionOrigin:
                obj.actionOrigin !== undefined && obj.actionOrigin !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.actionOrigin,
                      datex2Enums.actionOrigin
                    )
                  : '',
              operatorActionStatus:
                obj.operatorActionStatus !== undefined &&
                obj.operatorActionStatus !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.operatorActionStatus,
                      datex2Enums.operatorActionStatus
                    )
                  : '',
              mobilityType:
                obj.mobilityType !== undefined && obj.mobilityType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.mobilityType,
                      datex2Enums.mobility
                    )
                  : '',
              maintenanceVehicleActions:
                obj.maintenanceVehicleActions !== undefined &&
                obj.maintenanceVehicleActions !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.maintenanceVehicleActions,
                      datex2Enums.maintenanceVehicleActions
                    )
                  : '',
              equipmentOrSystemFaultType:
                obj.equipmentOrSystemFaultType !== undefined &&
                obj.equipmentOrSystemFaultType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.equipmentOrSystemFaultType,
                      datex2Enums.equipmentOrSystemFaultType
                    )
                  : '',
              faultyEquipmentOrSystemType:
                obj.faultyEquipmentOrSystemType !== undefined &&
                obj.faultyEquipmentOrSystemType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.faultyEquipmentOrSystemType,
                      datex2Enums.faultyEquipmentOrSystemType
                    )
                  : '',
              abnormalTrafficType:
                obj.abnormalTrafficType !== undefined &&
                obj.abnormalTrafficType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.abnormalTrafficType,
                      datex2Enums.abnormalTrafficType
                    )
                  : '',
              queueLength:
                obj.queueLength !== undefined && obj.queueLength !== null
                  ? obj.queueLength
                  : '',
              trafficFlowCharacteristics:
                obj.trafficFlowCharacteristics !== undefined &&
                obj.trafficFlowCharacteristics !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.trafficFlowCharacteristics,
                      datex2Enums.trafficFlowCharacteristics
                    )
                  : '',
              trafficTrendType:
                obj.trafficTrendType !== undefined &&
                obj.trafficTrendType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.trafficTrendType,
                      datex2Enums.trafficTrendType
                    )
                  : '',
              obstructionType:
                obj.obstructionType !== undefined &&
                obj.obstructionType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.obstructionType,
                      datex2Enums.obstructionType
                    )
                  : '',
              environmentalObstructionType:
                obj.environmentalObstructionType !== undefined &&
                obj.environmentalObstructionType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.environmentalObstructionType,
                      datex2Enums.environmentalObstructionType
                    )
                  : '',
              infrastructureDamageType:
                obj.infrastructureDamageType !== undefined &&
                obj.infrastructureDamageType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.infrastructureDamageType,
                      datex2Enums.infrastructureDamageType
                    )
                  : '',
              alive:
                obj.alive !== undefined && obj.alive !== null ? obj.alive : '',
              vehicleObstructionType:
                obj.vehicleObstructionType !== undefined &&
                obj.vehicleObstructionType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.vehicleObstructionType,
                      datex2Enums.vehicleObstructionType
                    )
                  : '',
              authorityOperationType:
                obj.authorityOperationType !== undefined &&
                obj.authorityOperationType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.authorityOperationType,
                      datex2Enums.authorityOperationType
                    )
                  : '',
              disturbanceActivityType:
                obj.disturbanceActivityType !== undefined &&
                obj.disturbanceActivityType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.disturbanceActivityType,
                      datex2Enums.disturbanceActivityType
                    )
                  : '',
              weatherRelatedRoadConditionType:
                obj.weatherRelatedRoadConditionType !== undefined &&
                obj.weatherRelatedRoadConditionType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.weatherRelatedRoadConditionType,
                      datex2Enums.weatherRelatedRoadConditionType
                    )
                  : '',
              poorEnvironmentType:
                obj.poorEnvironmentType !== undefined &&
                obj.poorEnvironmentType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.poorEnvironmentType,
                      datex2Enums.poorEnvironmentType
                    )
                  : '',
              constructionWorkType:
                obj.constructionWorkType !== undefined &&
                obj.constructionWorkType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.constructionWorkType,
                      datex2Enums.constructionWorkType
                    )
                  : '',
              roadMaintenanceType:
                obj.roadMaintenanceType !== undefined &&
                obj.roadMaintenanceType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.roadMaintenanceType,
                      datex2Enums.roadMaintenanceType
                    )
                  : '',
              generalNetworkManagementType:
                obj.generalNetworkManagementType !== undefined &&
                obj.generalNetworkManagementType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.generalNetworkManagementType,
                      datex2Enums.generalNetworkManagementType
                    )
                  : '',
              complianceOption:
                obj.complianceOption !== undefined &&
                obj.complianceOption !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.complianceOption,
                      datex2Enums.complianceOption
                    )
                  : '',
              automaticallyInitiated:
                obj.automaticallyInitiated !== undefined &&
                obj.automaticallyInitiated !== null
                  ? obj.automaticallyInitiated
                  : '',
              speedManagementType:
                obj.speedManagementType !== undefined &&
                obj.speedManagementType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.speedManagementType,
                      datex2Enums.speedManagementType
                    )
                  : '',
              temporarySpeedLimit:
                obj.temporarySpeedLimit !== undefined &&
                obj.temporarySpeedLimit !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.temporarySpeedLimit,
                      datex2Enums.temporarySpeedLimit
                    )
                  : '',
              winterEquipmentManagementType:
                obj.winterEquipmentManagementType !== undefined &&
                obj.winterEquipmentManagementType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.winterEquipmentManagementType,
                      datex2Enums.winterEquipmentManagementType
                    )
                  : '',
              generalInstructionToRoadUsersType:
                obj.generalInstructionToRoadUsersType !== undefined &&
                obj.generalInstructionToRoadUsersType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.generalInstructionToRoadUsersType,
                      datex2Enums.generalInstructionToRoadUsersType
                    )
                  : '',
              roadOrCarriagewayOrLaneManagementType:
                obj.roadOrCarriagewayOrLaneManagementType !== undefined &&
                obj.roadOrCarriagewayOrLaneManagementType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.roadOrCarriagewayOrLaneManagementType,
                      datex2Enums.roadOrCarriagewayOrLaneManagementType
                    )
                  : '',
              roadsideServiceDisruptionType:
                obj.roadsideServiceDisruptionType !== undefined &&
                obj.roadsideServiceDisruptionType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.roadsideServiceDisruptionType,
                      datex2Enums.roadsideServiceDisruptionType
                    )
                  : '',
              roadOperatorServiceDisruptionType:
                obj.roadOperatorServiceDisruptionType !== undefined &&
                obj.roadOperatorServiceDisruptionType !== null
                  ? datex2EnumsTranscodeFilter(
                      obj.roadOperatorServiceDisruptionType,
                      datex2Enums.roadOperatorServiceDisruptionType
                    )
                  : '',
            };
            csvData.push(row);
          }
        });
      }
      return csvData;
    };

    situationRecord.formatCurSituationRecordDates = function (sr) {
      if (sr.createdDate)
        sr.createdDate = zonedDateTimeToDateFilter(sr.createdDate);
      if (sr.updatedDate)
        sr.updatedDate = zonedDateTimeToDateFilter(sr.updatedDate);
      if (sr.validityPeriods) {
        angular.forEach(sr.validityPeriods, function (period) {
          if (period.dateStart)
            period.dateStart = zonedDateTimeToDateFilter(period.dateStart);
          if (period.dateEnd)
            period.dateEnd = zonedDateTimeToDateFilter(period.dateEnd);
          //console.log("testbar", period);
        });
      }
    };

    situationRecord.getUpdatedDate = function (sr) {
      if (sr.updatedDate) {
        sr.createdUpdateDate = sr.updatedDate;
      } else {
        sr.createdUpdateDate = sr.createdDate;
      }
    };

    situationRecord.getUpdatedBy = function (sr) {
      if (sr.updatedBy) {
        sr.createdUpdateBy = sr.updatedBy;
      } else {
        sr.createdUpdateBy = sr.createdBy;
      }
    };

    situationRecord.getIsPublic = function (sr) {
      sr.isPublic = false;
      if (sr.confidentiality && sr.confidentiality === 'NO_RESTRICTION') {
        sr.isPublic = true;
      }
    };

    situationRecord.getIsFuture = function (sr) {
      sr.isFuture = true;
      var now = moment.utc(moment(), 'YYYY-MM-DD  HH:mm:ss');
      if (sr.validityPeriods) {
        angular.forEach(sr.validityPeriods, function (period) {
          if (sr.isFuture) {
            var dateStart = moment.utc(
              period.dateStart,
              'YYYY-MM-DD  HH:mm:ss'
            );
            if (moment(dateStart).isBefore(now)) {
              sr.isFuture = false;
            }
          }
          //
        });
      }
    };

    situationRecord.getIsValid = function (sr) {
      //richiesta del cliente: pubblicare le notizie sul sito pubblico dal momento in cui sono inserite e fino al termine validità
      sr.isValid = false;
      var now = moment.utc(moment(), 'YYYY-MM-DD  HH:mm:ss');

      if (sr.validityPeriods) {
        angular.forEach(sr.validityPeriods, function (period) {
          //ciclo sui periodi di validità:
          //se trovo un periodo aperto (dateEnd==null)==>isValid=true
          //se trovo un periodo dateEnd!=null && dateEnd > now ==>isValid=true
          //altrimenti ==>isValid=false
          if (!sr.isValid) {
            if (!period.dateEnd) {
              sr.isValid = true;
            } else {
              var dateEnd = moment.utc(period.dateEnd, 'YYYY-MM-DD  HH:mm:ss');
              if (moment(dateEnd).isAfter(now)) {
                sr.isValid = true;
              }
            }
          }
        });
      }
    };

    return situationRecord;
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-AstralSituationRecord/components/services/situationRecordClass.js
// module id = 256
// module chunks = 0